import { Grid } from '@mui/material';
import Box from '@mui/material/Box';

import useAuthUser from 'hooks/useAuthUser';
import NewPageContent from 'layouts/NewPageContent';
import TransactionStat from './components/TransactionStat';
import KycStat from './components/KycStat';
import InboundStat from './components/InboundStat';
import OutboundStat from './components/OutboundStat';
import DashboardFilterForm from './components/DashboardFilterForm';

import { permissions } from 'app/data/permissions';
import { HasPermission } from 'hoc/withRole';

export default function Dashboard() {
  const user = useAuthUser();

  return (
    <Box sx={{ overflowX: 'auto', px: 0 }}>
      <NewPageContent
        documentTitle="Dashboard"
        titleStyle={{ fontSize: '1px', fontWeight: 'bold', color: '#1976d2', textAlign: 'center' }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DashboardFilterForm />
          </Grid>
          <HasPermission permission={permissions.VIEW_TXN_SUMMARY}>
            <Grid item xs={12} lg={5.5}>
              <TransactionStat />
            </Grid>
          </HasPermission>
          <HasPermission permission={permissions.VIEW_KYC_COUNT_SUMMARY}>
            <Grid item xs={12} lg={6.5}>
              <KycStat />
            </Grid>
          </HasPermission>
          <HasPermission permission={permissions.VIEW_INBOUND_PAYMENT_SUMMARY}>
            <Grid item xs={12} lg={5.5}>
              <InboundStat />
            </Grid>
          </HasPermission>
          <HasPermission permission={permissions.VIEW_OUTBOUND_PAYMENT_SUMMARY}>
            <Grid item xs={12} lg={6.5}>
              <OutboundStat />
            </Grid>
          </HasPermission>
        </Grid>
      </NewPageContent>
    </Box>
  );
}
